import { useEffect, useState } from 'react';
import { resolveEbookReaderKind, READER_KIND } from 'api/media/resolve-ebook-reader-kind';
import { isLCPEbookType, isPDFEbookType, isPubhubEbookType } from 'utils/assets';

const useEbookReaderKind = (activeQueueItem, isEbookReaderOpen) => {
  // null = no reader chosen yet (LCP probe in flight) or ebook reader closed
  const [readerKind, setReaderKind] = useState(null);

  useEffect(() => {
    let cancelled = false;

    if (!isEbookReaderOpen || !activeQueueItem) {
      setReaderKind(null);
      return undefined;
    }

    if (isPDFEbookType(activeQueueItem)) {
      setReaderKind(READER_KIND.pdf);
      return undefined;
    }

    if (isPubhubEbookType(activeQueueItem)) {
      setReaderKind(READER_KIND.pubhub);
      return undefined;
    }

    if (!isLCPEbookType(activeQueueItem)) {
      setReaderKind(null);
      return undefined;
    }

    setReaderKind(null);

    resolveEbookReaderKind(activeQueueItem).then((kind) => {
      if (!cancelled) {
        setReaderKind(kind);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [activeQueueItem, isEbookReaderOpen]);

  const isResolvingReader =
    isEbookReaderOpen &&
    !!activeQueueItem &&
    isLCPEbookType(activeQueueItem) &&
    readerKind === null;

  return { readerKind, isResolvingReader };
};

export default useEbookReaderKind;
